import Vue from 'vue'
import Users from '@/apiClient/Users'

const userInstance = new Users()

const userDocumentFile = () => {
  const store = Vue.observable({
    file: '',
    totalPages: ''
  })

  const setFile = async ({ idApp, idDoc }) => {
    const response = await userInstance.getDocumentFile(idApp, idDoc)
    const documentFile = `data:application/pdf;base64,${response}`
    store.file = documentFile
  }

  const setInitialValue = () => {
    store.file = ''
    store.totalPages = ''
  }

  const setTotalPages = total => (store.totalPages = total)

  return {
    store,
    setTotalPages,
    setFile,
    setInitialValue
  }
}

export default userDocumentFile
